<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Header -->
							<div class="page_header">Configure Department Reviewers</div>
							<!-- Header -->
							<div class="page_main">
								<!-- <div class="btn_el">
									<div class="tips">Description</div>
								</div> -->
				
								<!-- <div class="search_box">
									<div class="search_el">
										<div class="search_el_el">
											<div class="tit">If no default reviewer is specified, use the department manager?</div>
											<el-select v-model="isManager" placeholder="Please select" style="width: 100%;">
												<el-option label="Yes" :value="1"></el-option>
												<el-option label="No" :value="2"></el-option>
											</el-select>
										</div>
									</div>
								</div> -->
				
								<div class="table_box">
									<el-table 
										v-loading="tableLoading" 
										:data="tableData" 
										style="width: 100%;" 
										:row-key="getRowKey" 
										border 
										default-expand-all
										:tree-props="{children: 'children', hasChildren: 'hasChildren' }"
									>
										<el-table-column prop="company_name" label="Department Name">
											<template #default="scope">
												<div style="display: inline-block;">
													{{ scope.row.departments_name }}
												</div>
											</template>
										</el-table-column>
				
										<el-table-column prop="username" label="Department Manager">
										</el-table-column>
				
										<el-table-column prop="resources_username" label="Department Reviewer">
											<template #default="scope">
												<div v-if="scope.row.resources_username">
													{{ scope.row.resources_username }}
												</div>
												<div v-else>/</div>
											</template>
										</el-table-column>
				
										<el-table-column prop="id" label="Operation" width="180" align="center">
											<template #default="scope">
												<div v-if="scope.row.resources_username" class="inline_btn">
													<el-button 
														type="primary" 
														size="mini" 
														@click="handleClick('Change Reviewer', scope.row)"
													>
														Change Reviewer
													</el-button>
												</div>
												<div v-else>/</div>
											</template>
										</el-table-column>
				
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--选择用户-->
		<el-dialog title="Configure Department Reviewer - Select User" :visible.sync="userDialogVisible" width="55%">
			<selectUser
				v-if="userDialogVisible"
				:selectedId="selectedId"
				:departmentId="departmentId"
				type="document"
				@update-data="handleUpdateData"
			></selectUser>
		</el-dialog>
		<!--选择用户-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { departmentsLists } from '@/api/docManage/configureDocControl/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import selectUser from "@/component/select-user.vue";
export default {
	components:{
		headers,
		slider,
		selectUser
	},
	data() {
		return {
			isLoading: true,
			isManager: 1,
			tableData: [],
			userDialogVisible: false,
			selectedId: null,
			departmentId: null,
			tableLoading: false
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.getTableData();
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//请求数据
		getTableData() {
			let that = this;
			departmentsLists().then(res => {
				that.tableLoading = true;
				if(res.code == 200) {
					that.tableData = res.data;
					that.tableLoading = false;
					// that.handleClick('更换审核人', that.tableData[0].children[0]);
				}else {
					
				}
			});
		},
		getRowKey(row) {
			// 如果已经有 _rowKey，直接返回
			if (row._rowKey) return row._rowKey
			// 否则生成一个新的
			row._rowKey = `row_${this.keyCounter}_${Math.random()}_${Date.now()}`
			return row._rowKey
		},
		//操作按钮点击
		handleClick(name, value) {
			let that = this;
			switch (name) {
			    case 'Change Reviewer':
					that.departmentId = value.departments_id;
					that.selectedId = value.resources_userid;
					that.userDialogVisible = true;
				break;
			}
		},
		handleUpdateData() {
			let that = this;
			that.getTableData();
		},
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main{
	.page_main{
		padding: 18px 20px;
		//表格
		.table_box{
			width: 100%;
			padding-bottom: 20px;
			.inline_btn{
				display: inline-block;
			}
		}
		//搜索
		.search_box{
			.search_el{
				display: flex;
				padding-bottom: 10px;
				.search_el_el{
					flex: 1;
				}
				.mr_r{
					margin-right: 10px;
				}
				.mr_l{
					margin-left: 10px;
				}
			}
		}
		.btn_el{
			margin: 10px 0 20px 0;
			.tips{
				padding: 6px 8px;
				background-color: #ffb1001a;
				border-radius: 6px;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	//页头
	.page_header{
		padding: 0 20px;
		height: 60px;
		line-height: 60px;
		background-color: #d8e4f0;
		font-size: 24px;
		font-weight: bold;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
	}
}
</style>
<style scoped>
.main_box{
	height: calc(100vh - 60px);
	overflow-y: auto;
}
.main_box .main_main{
	position: relative;
	min-height: calc(100% - 0px);
	max-height: auto;
	background-color: #FAFAFA;
}
.el-header, .el-main{
	padding: 0;
}
::v-deep .btn span{
	text-decoration: underline;
}
</style>

